import { render, staticRenderFns } from "./CreateSciApplication.vue?vue&type=template&id=89006786"
import script from "./CreateSciApplication.vue?vue&type=script&lang=js"
export * from "./CreateSciApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports